import axios, { AxiosInstance, AxiosRequestConfig, InternalAxiosRequestConfig } from "axios";
import * as dotEnv from "lib/dotEnv";
import { Store } from "store";

export class AiSearchApiClient {
	private readonly axiosInstance: AxiosInstance;
	private readonly store: Store;

	constructor(store: Store) {
		this.store = store;
		this.axiosInstance = axios.create({
			baseURL: dotEnv.Get("AI_SEARCH_API_URL"),
			headers: {
				"accept": "application/json",
				"Content-Type": "application/json",
			},
		});
		this.axiosInstance.interceptors.request.use(
			(config: InternalAxiosRequestConfig) => {
				const token = this.store.getState().token.token;
				if (token) {
					config.headers.Authorization = `Bearer ${token}`;
				}
				return config;
			},
			(err) => Promise.reject(err)
		);
	}

	async Post<T>(
		url: string,
		data?: any,
		config?: AxiosRequestConfig
	): Promise<T> {
		const response = await this.axiosInstance.post<T>(url, data, config);
		return response.data;		
	}

	async Get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
		const response = await this.axiosInstance.get<T>(url, config);
		return response.data;
	}
}

// Singleton instance
let aiSearchApiInstance: AiSearchApiClient | null = null;

export function GetAiSearchApiInstance(store: Store): AiSearchApiClient {
	if (!aiSearchApiInstance) {
		aiSearchApiInstance = new AiSearchApiClient(store);
	}
	return aiSearchApiInstance;
}
